import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "photowall" }
const _hoisted_2 = ["src"]

import * as database from '@/services/database'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotosView',
  setup(__props) {

const photos = ref<database.Photo[]>([])

database.syncPhotos(dbPhotos => {
  photos.value = dbPhotos
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo) => {
      return (_openBlock(), _createElementBlock("div", {
        key: photo.id
      }, [
        _createElementVNode("img", {
          src: photo.imgString
        }, null, 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})